/**
 * @author annie
 * ajax calls
 */
angular.module('AppCtrl.contact.service', ['AppCtrl.jobvite.service', 'AppCtrl.contact.constant'])
    .value('CONTACTCONST', {
        debuggingEnabled: true,
        Urls: {
            'firstSearch': window.jvUrls.source + '/action/crm/facetedsearch/initialize',
            'searchContacts': window.jvUrls.source + '/action/crm/facetedsearch/search',
            'getContactDetailIds': window.jvUrls.source + '/action/crm/facetedsearch/idlist',
            'getMapping': window.jvUrls.source + '/action/crm/facetedsearch/mapping',
            'getAndFacets': window.jvUrls.admin + '/action/admin/configuration?properties=PIPELINE_AND_OPERATOR_FACETS',
            'saveAdminConfiguration': window.jvUrls.admin + '/action/admin/configuration',
            //modals
            'modalNoteTagMessageCampaignReq': window.jvUrls.source + '/action/person/contactList',
            'modalMergeExport': window.jvUrls.source + '/person/contacts.html?',
            'shareJobvite': window.jvUrls.source + '/source/share/shareJobvite.html',
            'campaigns': window.jvUrls.source + '/action/crm/campaigns/list',
            'contactDetails': window.jvUrls.source + '/person/contactDetails.html?ids={0}',
            'saveSearch': window.jvUrls.source + '/action/crm/facetedsearch/savedsearch',
            'reqsFilter': window.jvUrls.jhire + '/action/requisitions/filters',
            'addToReqs': window.jvUrls.source + '/action/person/contactList',
            'getContactsCount': window.jvUrls.source + '/action/crm/facetedsearch/contacts/count',
            'unlinkLinkedInProfile': window.jvUrls.source + '/action/contact/unLinkLinkedInProfile?contactEId={0}&memberToken={1}&unlink={2}',
            'linkedInCandidateSyncStatus': window.jvUrls.source + '/action/contact/candidateSyncStatus?contactEId={0}',
            'syncCandidateToLinkedIn': window.jvUrls.source + '/action/contact/syncContactToLinkedIn?contactEId={0}'
        }
    })

    .factory('logService', ['CONTACTCONST', function (CONST) {
        return function (message) {
            if (!CONST.debuggingEnabled) {
                return;
            }
            try {
                console.log(message);
            } catch (e) {}
        };
    }])

    //contact service that has all the api's for making modifications to the campaign.
    .factory('contactService', ['logService', 'makeAjaxCall', '$rootScope', 'CONTACTCONST', '$routeParams', '$timeout', '$q', '$http', function (logService, makeAjaxCall, $rootScope, CONTACTCONST, $routeParams, $timeout, $q, $http) {
        var contactService = {};
        contactService.pagesCacher = {};
        // Used for persisting the filters on the page.
        var _contactFilterObjects = null;



        /******************************************
         * Get longer name mappings to call backend with
         ******************************************/

        contactService.getMapping = function (args, callback) {
            callback = (callback || angular.noop);
            //console.log(args);
            var _mappingObject = {};
            // ajax url.
            _mappingObject['url'] = CONTACTCONST.Urls.getMapping;
            // Make a call to the backend and bind the promise with success.
            //console.log( _mappingObject );
            _mappingObject['ajaxtype'] = 'facetedMapping';
            if (args.mapping !== undefined) {
                callback();
            } else {
                var _getMap = makeAjaxCall(_mappingObject);
                _getMap.then(function (results) {
                    args.mapping = results.data.mapping;
                    cleanCategories(args);
                    //console.log(results);
                    callback();
                });
            }
        };

        //takes out params from the URL that do not match things in the mapping.
        var cleanCategories = function (args) {
            for (var key in args.facetMap) {
                var isCategory = (key in args.mapping);
                var kw = (key === 'kw');
                var openFacetFields = (key === 'openFacetFields');
                if (!(isCategory || kw)) {
                    //console.log(key+ ':' +args[key]);
                    delete args[key];
                }
            }
            //console.log(args);
        };

        // Helper method for creating search object.
        contactService.createSearchObjHelper = function (args, callback) {
            var _contactObject = {};
            // TODO: remove this hardcoded value afterwards from the jsp.
            //var _campaignId = $routeParams['ceid'] || _campaignObject['ceid'] || JV.CAMPAIGNEID;
            var facetFields = replaceLWithLv(args.openFacetFields);
            _contactObject['openFacetFields'] = facetFields;
            _contactObject['keywords'] = args.kw || '';
            _contactObject['location'] = args.l || '';
            if (args.latitude && args.latitude.trim() !== '' && args.longitude && args.longitude.trim() !== '') {
                _contactObject['latitude'] = args.latitude || '';
                _contactObject['longitude'] = args.longitude || '';
            }
            _contactObject['searchNameOnly'] = args.searchNameOnly;
            if (args.dataConsentStatus) {
                _contactObject['consentStatuses'] = [args.dataConsentStatus];
            }
            if (args.consentDateFrom && args.consentDateTo) {
                _contactObject['consentDateFrom'] = new Date(args.consentDateFrom);
                _contactObject['consentDateTo'] = new Date(args.consentDateTo);
            }
            if (args.autoDeletionDateFrom && args.autoDeletionDateTo) {
                _contactObject['autoDeletionDateFrom'] = new Date(args.autoDeletionDateFrom);
                _contactObject['autoDeletionDateTo'] = new Date(args.autoDeletionDateTo);
            }
            _contactObject['customFiltersString'] = JSON.stringify(args.customFiltersString);
            _contactObject['page'] = args.page || 0;
            _contactObject['maxResults'] = args.maxResults || '';
            //console.log(args.sortMapping);
            //console.log(args.sort);
            _contactObject['sortBy'] = angular.isDefined(args.sortMapping) && angular.isDefined(args.sort) ? args.sortMapping[args.sort].key || '-updatedate' : '-updatedate';
            addFacets(args, _contactObject);

            // ajax url.
            //logService(CONTACTCONST.Urls.searchContacts.format(_fetchFacetsOnly, _contactKeywords, _returnFacetFields));
            //_contactObject['url'] = CONTACTCONST.Urls.searchContacts.format(_fetchFacetsOnly, _contactKeywords, _facetFields);
            // POST
            _contactObject['requestType'] = 'POST';
            // ajaxtype for google analytics
            _contactObject['ajaxtype'] = 'facetedSearch';

            //When GDPR is enabled assigning the Anonymized Filter value to false, when the value is not explicitly passed from Controller method on UI action.
            //When Anonymized is set to false only non anonymized records will be fetched.
            if (window.JV.gdprEnabled === 'true') {
                _contactObject['anonymized'] = angular.isDefined(args) && args != null && angular.isDefined(args.anonymized) && args.anonymized != null && args.anonymized;
            }
            return _contactObject;
        };

        /******************************************
         * Get facets and list details
         ******************************************/
        contactService.searchContacts = function (args, callback) {
            let _contactObject = {};
            contactService.pagesCacher = {};
            callback = (callback || angular.noop);
            _contactObject = contactService.createSearchObjHelper(args, callback);
            _contactObject['url'] = CONTACTCONST.Urls.searchContacts;
            /**
             * Boradcast the results to all the listeners.
             * @param {Object} results: returned from the backend for a specific campaign.
             * @param {Object} callback: callback that needs to be called when the results come back. Most of the listeners will have a listener with the $on, so might not be used.
             */
            function broadSearchDetailResults(results, callback) {
                $rootScope.$broadcast('facetedContactResults', results.data);
                contactService.pagesCacher[_contactObject['page']] = results.data;
                callback(results.data);
            }
            //VA: Make a call here for the same object for the previous and next pages.
            //contactService.getPreviousNextPages(angular.copy(_contactObject), [parseInt(_contactObject['page'])-1, parseInt(_contactObject['page'])+1])

            // Make a call to the backend and bind the promise with success.
            var _getContactDetails = makeAjaxCall(_contactObject);
            _getContactDetails.then(function (results) {
                //console.log(results);
                broadSearchDetailResults(results, callback);
            });
        };

        /******************************************
         * Get facets and list details
         ******************************************/
        contactService.getContactDetailIds = function (args, callback) {
            let _contactObject = {};
            contactService.pagesCacher = {};
            callback = (callback || angular.noop);
            _contactObject = contactService.createSearchObjHelper(args, callback);
            _contactObject['url'] = CONTACTCONST.Urls.getContactDetailIds;

            // Make a call to the backend and bind the promise with success.
            var _getContactDetails = makeAjaxCall(_contactObject);
            _getContactDetails.then(function (results) {
                //console.log(results);
                callback(results);
            });
        };

        contactService.getContactsCount = function (args, callback) {
            contactService.pagesCacher = {};
            callback = (callback || angular.noop);
            const _contactObject = contactService.createSearchObjHelper(args, callback);
            _contactObject['url'] = CONTACTCONST.Urls.getContactsCount;

            // Make a call to the backend and bind the promise with success.
            var _getContactDetails = makeAjaxCall(_contactObject);
            _getContactDetails.then(function (results) {
                callback(results);
            });
        };

        //VA: cache the previous and next pages. This is for detail navigation when the user clicks on the bar arrows on the contact details page.
        contactService.getPreviousNextPages = function (contactSearchObject, pages) {
            //VA: TODO: remove the page if it is less then -1
            contactSearchObject['ajaxtype'] = 'facetedSearchPrefetch';
            var pages = pages;
            var _callback = function (results, page) {
                contactService.pagesCacher[page] = results;

            };
            angular.forEach(pages, function (value) {
                if (value !== -1) {
                    contactSearchObject['page'] = value;
                    if (value === 0) {
                        //VA: pass the third parameter so that it doesnt go into infinite loop.
                        contactService.initialize(null, function (result) {
                            _callback(result, 0);
                        })
                    } else {
                        var _cloneObj = angular.copy(contactSearchObject);
                        _cloneObj['url'] = CONTACTCONST.Urls.searchContacts;
                        _cloneObj['requestType'] = 'POST';
                        var _prefetchCall = makeAjaxCall(_cloneObj);
                        _prefetchCall.then(function (results) {
                            _callback(results.data, _cloneObj['page']);
                        });
                    }
                }
            });
        };

        var addFacets = function (args, result) {
            for (var key in args.facetMap) {
                if (key in args.mapping) {
                    result[args.mapping[key]] = args.facetMap[key].values;
                }
            }
        };

        var replaceLWithLv = function (original) {
            var result = original;
            if ($.inArray('l', result) !== -1) {
                result.splice(result.indexOf('l'), 1);
                result.push('lv');
            }
            return result;
        };

        /******************************************
         * Get facets and list details for the first time
         ******************************************/
        contactService.initialize = function (args, callback) {
            callback = (callback || angular.noop);
            /**
             * Boradcast the results to all the listeners.
             * @param {Object} results: returned from the backend for a specific campaign.
             * @param {Object} callback: callback that needs to be called when the results come back. Most of the listeners will have a listener with the $on, so might not be used.
             */
            function broadSearchDetailResults(results, callback) {
                $rootScope.$broadcast('facetedContactResults', results.data);
                callback(results.data);
                contactService.pagesCacher[0] = results.data;
            }
            var _contactObject = {};
            // ajax url.
            //logService(CONTACTCONST.Urls.searchContacts.format(_fetchFacetsOnly, _contactKeywords, _returnFacetFields));
            //_contactObject['url'] = CONTACTCONST.Urls.searchContacts.format(_fetchFacetsOnly, _contactKeywords, _facetFields);
            _contactObject['url'] = CONTACTCONST.Urls.firstSearch;
            // POST
            _contactObject['requestType'] = 'GET';
            // ajaxtype for google analytics
            _contactObject['ajaxtype'] = 'facetedSearch';
            // Make a call to the backend and bind the promise with success.
            var _getContactDetails = makeAjaxCall(_contactObject);
            _getContactDetails.then(function (results) {
                broadSearchDetailResults(results, callback);
            });
        };

        /******************************************
         * Get single facet
         ******************************************/
        contactService.openFacet = function (args, callback) {
            callback = (callback || angular.noop);
            /**
             * Boradcast the results to all the listeners.
             * @param {Object} results: returned from the backend for a specific campaign.
             * @param {Object} callback: callback that needs to be called when the results come back. Most of the listeners will have a listener with the $on, so might not be used.
             */
            function broadSearchDetailResults(results, callback) {
                $rootScope.$broadcast('expandedFacetField', results.data);
                callback(results.data);
            }
            var _contactObject = {};
            // TODO: remove this hardcoded value afterwards from the jsp.
            //var _campaignId = $routeParams['ceid'] || _campaignObject['ceid'] || JV.CAMPAIGNEID;
            //console.log(args);
            _contactObject['openFacetFields'] = args.singleFacet;
            _contactObject['fetchFacetsOnly'] = true;
            _contactObject['keywords'] = args.kw || '';
            _contactObject['location'] = args.l || '';
            _contactObject['searchNameOnly'] = args.searchNameOnly;
            _contactObject['page'] = args.page || 0;
            addFacets(args, _contactObject);

            // ajax url.
            //logService(CONTACTCONST.Urls.searchContacts.format(_fetchFacetsOnly, _contactKeywords, _returnFacetFields));
            //_contactObject['url'] = CONTACTCONST.Urls.searchContacts.format(_fetchFacetsOnly, _contactKeywords, _facetFields);
            _contactObject['url'] = CONTACTCONST.Urls.searchContacts;
            // POST
            _contactObject['requestType'] = 'POST';
            // ajaxtype for google analytics
            _contactObject['ajaxtype'] = 'facetedSearch-openFacet' + args.singleFacet;
            // Make a call to the backend and bind the promise with success.
            var _getContactDetails = makeAjaxCall(_contactObject);
            _getContactDetails.then(function (results) {
                //console.log(results);
                broadSearchDetailResults(results, callback);
            });
        };

        /******************************************
         * SaveSearch
         ******************************************/
        contactService.saveSearch = function (args, callback) {
            callback = (callback || angular.noop);

            var _saveSearchObject = {};
            _saveSearchObject.url = CONTACTCONST.Urls.saveSearch; //hook this up to backend
            _saveSearchObject.searchName = args.name;
            _saveSearchObject.searchUrl = args.url;
            _saveSearchObject['ajaxtype'] = 'saveSearch';
            _saveSearchObject['requestType'] = 'POST';

            var _saveSearchAction = makeAjaxCall(_saveSearchObject);
            _saveSearchAction.then(function (results) {
                callback();
            });
        };

        /******************************************
         * Modals
         ******************************************/
        contactService.performAction = function (args, callback) {
            callback = (callback || angular.noop);
            if (typeof args.eids === 'undefined' || args.action === 'undefined' || args.eids.length === 0) {
                try {
                    $rootScope.$broadcast('showSelectionMsg');
                } catch (e) {}
                return;
            }
            var _contactActionObject = {};

            switch (args.action) {
                case 'note':
                    _contactActionObject.url = CONTACTCONST.Urls.modalNoteTagMessageCampaignReq;
                    _contactActionObject.action = 'doAddNote';
                    _contactActionObject.message = args.content;
                    break;
                case 'tag':
                    _contactActionObject.url = CONTACTCONST.Urls.modalNoteTagMessageCampaignReq;
                    _contactActionObject.action = 'doAddTag';
                    _contactActionObject.tagNames = args.content.split(',');
                    break;
                case 'message':
                    _contactActionObject.url = CONTACTCONST.Urls.modalNoteTagMessageCampaignReq;
                    //load message and subject for ajax call
                    _contactActionObject.action = 'doSendMessage';
                    _contactActionObject.subject = args.content.subject;
                    _contactActionObject.message = args.content.message;
                    break;
                case 'seekConsent':
                    _contactActionObject.url = CONTACTCONST.Urls.modalNoteTagMessageCampaignReq;
                    //load message and subject for ajax call
                    _contactActionObject.action = 'doSeekConsent';
                    _contactActionObject.subject = args.content.subject;
                    _contactActionObject.message = args.content.message;
                    break;
                case 'campaign':
                    _contactActionObject.url = CONTACTCONST.Urls.modalNoteTagMessageCampaignReq;
                    _contactActionObject.action = 'doAddToCampaign';
                    _contactActionObject.campaignIds = args.content?.eid;
                    _contactActionObject.identifier = 'addToCampaign';
                    break;
                case 'addContactsToReqs':
                    _contactActionObject.url = CONTACTCONST.Urls.modalNoteTagMessageCampaignReq;
                    _contactActionObject.action = 'addContactsToReqs';
                    _contactActionObject.jobIds = args.jobIds;
                    break;
                default:
                    // default
            }

            // analytics
            _contactActionObject['ajaxtype'] = args.action;
            _contactActionObject['requestType'] = 'POST';
            _contactActionObject.ids = args.eids;
            //console.log(_contactActionObject);
            var _performContactAction = makeAjaxCall(_contactActionObject);
            _performContactAction.then(function (results) {
                //console.log(args.eids.length);
                contactService.selectedEidslength = args.eids.length;
                callback(results);
                //campaignService.getCampaigns( );
                //what happens after the ajax call? nothing i guess... grid should still be normal
            });
        };

        /******************************************
         * Get the campaign Grid objects with no broadcast
         ******************************************/
        contactService.getCampaignsNoBroadcast = function (args, callback) {
            callback = (callback || angular.noop);
            const _campaignFilterObjects = args || {};

            _campaignFilterObjects.page = (!!args && !!args.page && args.page > 0) ? args.page : 0;
            //VA: restrict max results for the modal to 10 only.
            _campaignFilterObjects.maxResults = 10;
            _campaignFilterObjects['url'] = CONTACTCONST.Urls.campaigns;
            _campaignFilterObjects['ajaxtype'] = 'getCampaigns';
            var _getCampaigns = makeAjaxCall(_campaignFilterObjects);
            _getCampaigns.then(function (results) {
                callback(results.data);
            });
        };

        /*****
         * redirected actions
         ****/

        contactService.getUrl = function (place, eids) {
            if (place === 'merge') {
                return CONTACTCONST.Urls.modalMergeExport + 'action=getDuplicateContacts&id=' + eids;
            }
            if (place === 'export') {
                return CONTACTCONST.Urls.modalMergeExport + 'action=exportContacts&ids=' + eids;
            }
        };

        contactService.postToContactDetails = function (args) {
            if (angular.isUndefined(args) || angular.isUndefined(args.ids)) {
                return;
            }
            if (jvGetQueryParamByName('campaigneid') && jvGetQueryParamByName('campaigneid').trim() !== '') {
                parent.goToContact(args.ids);
                return;
            }
            var form = document.createElement('form');
            form.id = 'temporaryJobviteForm';
            form.method = 'post';
            form.action = CONTACTCONST.Urls.contactDetails.format(args.ids);
            var input = document.createElement('input');
            angular.element(input).attr('name', 'contactIds');
            angular.element(input).attr('value', args.contactIds);
            angular.element(input).appendTo(form);
            var input1 = document.createElement('input');
            angular.element(input1).attr('name', 'totalContactIds');
            angular.element(input1).attr('value', args.totalContactIds);
            angular.element(input1).appendTo(form);
            document.body.appendChild(form);
            $('#temporaryJobviteForm').trigger('submit');
        };

        contactService.shareJobvite = function (referrer, emails) {
            var form = document.createElement('form');
            form.id = 'temporaryJobviteForm';
            form.method = 'post';
            form.action = CONTACTCONST.Urls.shareJobvite;
            var input = document.createElement('input');
            angular.element(input).attr('name', 'sjEmails');
            angular.element(input).attr('value', emails.join(' '));
            angular.element(input).appendTo(form);
            document.body.appendChild(form);
            $('#temporaryJobviteForm').trigger('submit');
        };

        contactService.saveAndFacets = function (facets) {
            var data = [{
                configurationName: 'PIPELINE_AND_OPERATOR_FACETS',
                enabled: true,
                visible: true,
                attributes: {
                    value: facets.join(',')
                }
            }];
            return $http.post(CONTACTCONST.Urls.saveAdminConfiguration, data);
        };


        contactService.getReqsFilters = function (callback) {
            callback = (callback || angular.noop);
            var _reqsFilter = {};
            _reqsFilter['url'] = CONTACTCONST.Urls.reqsFilter;
            _reqsFilter['ajaxtype'] = 'getReqsFilters';
            var _getReqsFilters = makeAjaxCall(_reqsFilter);
            _getReqsFilters.then(function (results) {
                callback(results.data);
            });
        };

        /******************************************
         * Unlink LinkedIn Profile
         ******************************************/
        contactService.unlinkLinkedInProfile = function (args) {
            var _unlinkLinkedInProfileObjects = {};
            _unlinkLinkedInProfileObjects['url'] = CONTACTCONST.Urls.unlinkLinkedInProfile.format(args.contactEid, args.memberToken, args.unlink);
            _unlinkLinkedInProfileObjects['ajaxtype'] = 'unlinkLinkedInProfile';
            var _getUnlinkProfile = makeAjaxCall(_unlinkLinkedInProfileObjects);
            _getUnlinkProfile.then(function (results) {});
        };

        contactService.getLinkedInCandidateSyncStatus = function (args, callback) {
            var _syncStatusObject = {};
            _syncStatusObject['url'] = CONTACTCONST.Urls.linkedInCandidateSyncStatus.format(args.contactEid);
            _syncStatusObject['ajaxtype'] = 'linkedInCandidateSyncStatus';
            var _getSyncStatus = makeAjaxCall(_syncStatusObject);
            _getSyncStatus.then(function (results) {
                callback(results.data);
            });
        };

        contactService.syncCandidateToLinkedIn = function (args, callback) {
            var _syncStatusObject = {};
            _syncStatusObject['url'] = CONTACTCONST.Urls.syncCandidateToLinkedIn.format(args.contactEid);
            _syncStatusObject['ajaxtype'] = 'syncCandidateToLinkedIn';
            var _getSyncStatus = makeAjaxCall(_syncStatusObject);
            _getSyncStatus.then(function (results) {
                callback(results.data);
            });
        };
        return contactService;
    }]);